export default __webpack_public_path__ + "static/media/773.738f8e9f.png";